import BookACallButton from '../Buttons/Specials/BookACallButton'

const SVGBG = () => (
    <svg
        width="790"
        height="330"
        viewBox="0 0 790 320"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M789 159.693C789 376.679 612.684 552.586 395.183 552.586C177.681 552.586 1.36572 376.679 1.36572 159.693C1.36572 -57.2933 177.681 -233.199 395.183 -233.199C612.684 -233.199 789 -57.2933 789 159.693Z"
            stroke="#F15A22"
            strokeOpacity="0.3"
            strokeWidth="2"
        />
        <path
            d="M71.2005 160.273C71.2005 -18.4672 216.098 -163.364 394.838 -163.364C573.578 -163.364 718.475 -18.4672 718.475 160.273C718.475 339.013 573.578 483.91 394.838 483.91C216.098 483.91 71.2005 339.013 71.2005 160.273Z"
            stroke="#F15A22"
            strokeOpacity="0.3"
            strokeWidth="2"
        />
        <path
            d="M154.247 160.273C154.247 27.3981 261.963 -80.3179 394.838 -80.3179C527.712 -80.3179 635.428 27.3981 635.428 160.273C635.428 293.147 527.712 400.863 394.838 400.863C261.963 400.863 154.247 293.147 154.247 160.273Z"
            stroke="#F15A22"
            strokeOpacity="0.3"
            strokeWidth="2"
        />
    </svg>
)

const CallAction = ({ CallActionButton = BookACallButton, children }) => {
    return (
        <div className="relative max-w-7xl mx-auto px-4">
            {/* Centered SVG Background */}
            <div className="flex absolute inset-0 justify-center items-center px-6 md:px-0">
                <SVGBG className="w-[500px] h-[200px] md:w-[790px] md:h-[320px]" />
            </div>
            {/* Foreground Content */}
            <div className="relative bg-olm-mid-yellow flex flex-col lg:flex-row justify-between rounded-lg shadow-lg text-center lg:text-left">
                <div className="flex justify-center lg:justify-start">
                    <img
                        src="/assets/coaching/call-action-left.png"
                        alt="envelope"
                        className="w-full lg:w-auto hidden md:block"
                    />
                    <img
                        src="/assets/coaching/mobile-call-action-left.png"
                        alt="envelope"
                        className="w-full lg:w-auto md:hidden"
                    />
                </div>
                <div className="py-4 z-10 md:py-12 px-4 lg:px-0 text-center flex items-center">
                    <div>
                        {children}
                        <div className="max-w-xl md:w-96 w-full m-auto">
                            <CallActionButton />
                        </div>
                    </div>
                </div>
                <div className="flex rounded-lg relative justify-center lg:justify-end">
                    <img
                        src="/assets/coaching/call-action-right.png"
                        alt="envelope"
                        className="w-full rounded-lg lg:w-auto hidden md:block"
                    />
                    <img
                        src="/assets/coaching/mobile-call-action-right.png"
                        alt="envelope"
                        className="w-full rounded-lg lg:w-auto md:hidden -mt-20"
                    />
                </div>
            </div>
        </div>
    )
}

export default CallAction
